export const OPEN_MODAL = 'containers/PaymentModal/OPEN_MODAL';
export const CLOSE_MODAL = 'containers/PaymentModal/CLOSE_MODAL';
export const MODAL_SUBMIT = 'containers/PaymentModal/MODAL_SUBMIT';

export const SHOW_LOADING_FULL_SCREEN = 'containers/PaymentModal/SHOW_LOADING_FULL_SCREEN';
export const HIDE_LOADING_FULL_SCREEN = 'containers/PaymentModal/HIDE_LOADING_FULL_SCREEN';
